import React from "react";
import { FaFacebookF, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* ===== FOOTER TOP ===== */}
        <div className={styles.footerTop}>
          {/* Brand & Contact Section */}
          <div className={styles.brandSection}>
            <div className={styles.logoWrapper}>
              <img src="/logo/logo.png" alt="Exademy" className={styles.logo} />
              <span className={styles.companyName}>Exademy</span>
            </div>
            
            <div className={styles.brandDescription}>
              India's premier mathematics optional coaching platform. Empowering aspirants to crack UPSC, BPSC, and State PSC examinations since 2019.
            </div>

            <div className={styles.contactInfo}>
              <h4>Contact Us</h4>
              <div className={styles.contactItem}>
                <i className="fas fa-phone-alt"></i>
                <span>+91 7847820335</span>
              </div>
              <div className={styles.contactItem}>
                <i className="fas fa-envelope"></i>
                <span>info@exademy.in</span>
              </div>
              <div className={styles.contactItem}>
                <i className="fas fa-map-marker-alt"></i>
                <span>Bhagalpur • Online</span>
              </div>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className={styles.linksSection}>
            <div className={styles.linkColumn}>
              <h4>Company</h4>
              <Link to="/about-us">About Us</Link>
              <Link to="/careers">Careers</Link>
              <Link to="/contact-us">Contact Us</Link>
              <Link to="/verify">E-Verify</Link>
            </div>

            <div className={styles.linkColumn}>
            <h4>Community</h4>
            <Link to="/become-mentor">Become a Mentor</Link>
            <Link to="/write-feedback">Write a Feedback</Link>
            <a 
              href="https://exademy.ezexam.in/login" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Exam Panel
            </a>
            <Link to="/FAQ-Page">FAQs</Link>
          </div>

            <div className={styles.linkColumn}>
              <h4>Policies</h4>
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/refund-policy">Refund Policy</Link>
              <Link to="/blog">Blog</Link>
            </div>
          </div>
        </div>

        {/* ===== FOOTER BOTTOM ===== */}
        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            © {currentYear} Exademy. All Rights Reserved.
          </div>
          
          <div className={styles.socialSection}>
            <div className={styles.socialIcons}>
              <a 
                href="https://www.youtube.com/@Exademyeducation" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="YouTube"
                className={styles.socialIcon}
              >
                <FaYoutube />
              </a>
              <a 
                href="https://www.linkedin.com/showcase/exademy/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className={styles.socialIcon}
              >
                <FaLinkedinIn />
              </a>
              <a 
                href="https://www.facebook.com/exademybharat?rdid=wjNKOay560WljROL&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1CVQKZE25n%2F%3Fref%3D1#" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
                className={styles.socialIcon}
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Wave */}
      <div className={styles.footerWave}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#0B5E42" fillOpacity="0.03" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </footer>
  );
};

export default Footer;